export default __webpack_public_path__ + "fonts/SanFranciscoDisplay-Bold.708bb21ee32098156b21e4bc8c7c9507.eot";